import { render, staticRenderFns } from "./DisplayKindKA.vue?vue&type=template&id=e089ea2c&scoped=true&"
import script from "./DisplayKindKA.vue?vue&type=script&lang=js&"
export * from "./DisplayKindKA.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindKA.vue?vue&type=style&index=0&id=e089ea2c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e089ea2c",
  null
  
)

export default component.exports